'use client';

import moment from 'moment';
import { useCallback } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux-hooks';
import { updateVisibility } from 'src/redux/modals/slice';

interface JobDescription {
  is_latest_job_description?: boolean;
  created_at?: string;
  service_category?: string;
  note?: string;
  [key: string]: unknown;
}

const DescriptionHistoryModal = () => {
  const dispatch = useAppDispatch();
  const timeZone = useAppSelector((state: Record<string, unknown>) => {
    const jobDetails = state?.jobDetails as Record<string, unknown> | undefined;
    const data = jobDetails?.data as Record<string, unknown> | undefined;
    return data?.timezone as string | undefined;
  });

  const handleCloseModal = useCallback(
    () => {
      dispatch(updateVisibility({ modalType: 'descriptionHistoryModal', isVisible: false }));
    },
    [dispatch],
  );

  const jobDetailsData = useAppSelector((state: Record<string, unknown>) => {
    const jobDetails = state?.jobDetails as Record<string, unknown> | undefined;
    return jobDetails?.data as Record<string, unknown> | undefined;
  });
  const jobDescriptions = (jobDetailsData?.job_descriptions || []) as JobDescription[];

  return (
    <Modal isOpen toggle={handleCloseModal} centered className="job-description-history-modal">
      <ModalHeader toggle={handleCloseModal}>Job Description History</ModalHeader>
      <ModalBody>
        <div className="modal-body-inner">
          <div className="activity-log-outer">
            {jobDescriptions?.map((item) => (
              <div
                key=""
                className={`activity-log ${
                  !item?.is_latest_job_description
                    ? 'system-update' : ''
                }`}
              >
                {timeZone
                  ? (
                    <div className="activity-log-header">
                      <div className="activity-log-time">
                        {item?.is_latest_job_description
                          ? (
                            <span>
                              {`Current Version (Updated ${
                                moment.utc(item?.created_at)
                                  ?.tz(timeZone)
                                  ?.format(
                                    'MMM D, YYYY, h:mm a z',
                                  )
                              })`}
                            </span>
                          )
                          : `${moment.utc(item?.created_at)
                            ?.tz(timeZone)
                            ?.format(
                              'MMM D, YYYY, h:mm a z',
                            )}`}
                      </div>
                    </div>
                  )
                  : ''}
                <div className="activity-log-inner">
                  <p className="mb-0">
                    <span>{item?.service_category}</span>
                  </p>
                  <p>
                    {`${item?.note || ''}`}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default DescriptionHistoryModal;
